export default "__VITE_ASSET__rRHM2ELW__"